$('a#package-products.reveal-btn').on('click', function (e) {
    e.preventDefault();

    var self = $(this);
    var container = self.parent().prev();

    if (self.hasClass('active')) {
        container.slideUp();
        self.removeClass('active');
        self.text('Show all products');
    } else {
        container.slideDown();
        self.addClass('active');
        self.text('Show less products');
    }
});

$('.package-enquire').on('click', function (e) {
    e.preventDefault();
    $.scrollTo('#enquiry', 750);
});
